import React from 'react';

import { AssignmentsListPage } from '../../shared/assignments';
import { ORGANIZATION_ASSIGNMENTS_LIST_QUERY_KEY } from './queryKeys';

const QUEUE_CATEGORY = 'HealthcareEntityAssignmentQueueNames';

export const AssignmentsList: React.FC = () => {
  return (
    <AssignmentsListPage
      title="Assignments"
      queryKeyBase={ORGANIZATION_ASSIGNMENTS_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationAssignments"
      showOrganization={false}
      linkContext="organization"
      queueCategory={QUEUE_CATEGORY}
    />
  );
};
